<template>
  <div class="aboutus">
    <div class="info-top">
      <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{Aboutus.Aboutus}}</div>
          <!-- <div class="top-message">{{Aboutus.AboutusIntroduce}}</div> -->
        </div>
      </div>
      <!-- <img src="@/assets/my/head.jpg" alt="">
      <div class="top-mess">{{Aboutus.Aboutus}}</div>
      <div class="top-message">{{Aboutus.AboutusIntroduce}}</div> -->
    </div>
    
    <div class="info-bot">
      <!-- <div class="zijg">
        <div class="tops" style="width: 100%;">
          <div class="bot-line" style="margin-top: 30px;"></div>
          <div class="bot-tit">
            {{Aboutus.organizationalStructure}}
            <div class="bot-bg">organizational structure</div>
          </div>
        </div>
        <div class="bg">
          <img style="max-width: 1200px;" v-if="$i18n.locale=='zh'" src="../../assets/home/my.jpg"/>
          <img style="max-width: 1200px;" v-else src="../../assets/home/myen.jpg"/>
         
        </div>
      </div> -->
      <div class="cont1">
      <div class="body-cont" id="clbj">
        <div class="bot-line" style="margin-top: 30px;"></div>
        <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
          {{Aboutus.BackgroundOfestablishment}}
          <div class="bot-bg">Background</div>
        </div>
        <div class="bot-cont">
        <div class="cont-tit t1">
          {{Aboutus.BackgroundOfestablishmentTxt}}
        </div>

        <div class="items10 pc">
          <div class="boxImg">
            <img src="../../assets/my/t0.png"/>
          </div>
          <div class="name">
            <div class="numbar" v-if="$i18n.locale=='zh'">2024年10月</div>
            <div class="numbar" v-else>October 2024</div>
            <div class="xians"></div>
          </div>
          <div class="boxName">{{Aboutus.Year202410}}</div>
        </div>

        <div class="listw">
          <div class="items">
            <img src="../../assets/my/t1.png"/>
            <div class="name">
              <div class="numbar" v-if="$i18n.locale=='zh'">2022年</div>
              <div class="numbar" v-else>2022</div>
              <div class="xians"></div>
            </div>
            <div class="txt">{{Aboutus.Year2022}}</div>
          </div>
          <div class="jtBox">
            <img class="jt" src="../../assets/my/jt.png"/>
          </div>
          
          <div class="items">
            <img src="../../assets/my/t2.png"/>
            <div class="name">
              <div class="numbar" v-if="$i18n.locale=='zh'">2023年8月</div>
              <div class="numbar" v-else>August 2023</div>
              <div class="xians"></div>
            </div>
            <div class="txt">{{Aboutus.Year202308}}</div>
          </div>
          <div class="jtBox special">
            <img class="jt" src="../../assets/my/jt.png"/>
          </div>
          <div class="items">
            <img src="../../assets/my/t3.png"/>
            <div class="name">
              <div class="numbar" v-if="$i18n.locale=='zh'">2024年6月</div>
              <div class="numbar" v-else>June 2024</div>
              <div class="xians"></div>
            </div>
            <div class="txt">{{Aboutus.Year202406}}</div>
          </div>
          <div class="jtBox">
            <img class="jt" src="../../assets/my/jt.png"/>
          </div>
          <div class="items">
            <img src="../../assets/my/t4.png"/>
            <div class="name">
              <div class="numbar" v-if="$i18n.locale=='zh'">2024年7月</div>
              <div class="numbar" v-else>July 2024</div>
              <div class="xians"></div>
            </div>
            <div class="txt">{{Aboutus.Year202407}}</div>
          </div>
        </div> 
        <div class="items10 yd">
          <div class="boxImg">
            <img src="../../assets/my/t0.png"/>
          </div>
          <div class="name">
            <div class="numbar" v-if="$i18n.locale=='zh'">2024年10月</div>
            <div class="numbar" v-else>October 2024</div>
            <div class="xians"></div>
          </div>
          <div class="boxName">{{Aboutus.Year202410}}</div>
        </div>
          
        </div>
      </div>
    </div>
      <div id="zxfw">
        <div class="zxfw-box">
          <div class="bot-line" style="margin-top: 30px;"></div>
          <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
            {{Aboutus.CenterServices}}
            <div class="bot-bg">Central Vision</div>
          </div>
          <div class="context">
            {{Aboutus.CenterServicesTxt}}
          </div>
        </div>
        <!-- <div class="bot-line" style="background: #fff;margin-top: 30px;"></div>
        <div class="bot-tit">
          {{Aboutus.CenterServices}}
          <div class="bot-bg">Central Vision</div>
        </div>
        <div class="context">
          {{Aboutus.CenterServicesTxt}}
        </div> -->
      </div>
      <div class="bot-hz">
        <div class="bot-line" style="margin-top: 30px;"></div>
        <div class="bot-tit" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
          {{Aboutus.KeyAreasOfCooperation}}
          <div class="bot-bg">Collaboration focus</div>
        </div>
      </div>
      <div class="newBox">
        <div class="insd"> {{Aboutus.KeyAreasOfCooperationTxt}}</div>
        <div class="list">
          <div class="items">
            <div class="img">01</div>
            <div class="txt"> {{Aboutus.TechnicalCooperation}}</div>
          </div>
          <div class="items">
            <div class="img">02</div>
            <div class="txt"> {{Aboutus.ProjectCooperation}}</div>
          </div>
          <div class="items">
            <div class="img">03</div>
            <div class="txt"> {{Aboutus.CapacityEnhancement}}</div>
          </div>
          <div class="items">
            <div class="img">04</div>
            <div class="txt"> {{Aboutus.StandardSpecifications}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  components: {
    Swiper,
  },
  data() {
    return {
      sectionId:'',
      yy: localStorage.getItem('yy') || 'zh'
    };
  },
  computed:{
    Aboutus(){
      return this.$t('Aboutus')
    }
  },
  watch: {
    '$route':function(vals,olds){
      this.isSelect = vals.name;
      if(vals.name == '活动详情'){
        this.isSelect = '中心成果';
      }
      if(vals.name == '详情'){
        if(vals.query.tit1){
          this.isSelect = vals.query.tit1;
        }  
      }
    },
  },
  mounted() {
    // setInterval(()=>{
    //   this.yy = sessionStorage.getItem('yy')
    // },500)
    this.initializeEventListener();
    this.delLoop();
  },
  methods: {
    initializeEventListener() {
      let that = this;
      this.$bus.$off("changePont");
      this.$bus.$on("changePont", (sectionId) => {
        this.sectionId = sectionId.isPont;
          this.$nextTick(() => {
            that.scrollTo(this.sectionId);
          });
      });
    },
    scrollTo(sectionId) {
      this.$nextTick(()=>{
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      })
    },
    delLoop() {
      new Swiper(".swiper3", {
        // direction: "vertical", // 垂直切换选项
        loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pc{
  display: block;
}
.yd{
  display: none;
}
.items10{
  margin-bottom: 50px;
  .boxImg{
    width: 200px;
    height: 200px;
    margin: 0 auto;
    margin-bottom: 20px;
    img{
      width: 200px;
      height: 200px;
    }
  }
  .name{
    margin-bottom: 20px;
    .numbar{
      font-family: "Microsoft YaHei";
      font-weight: bold;
      font-size: 30px;
      color: #67B7FB;
      line-height: 30px;
      background: linear-gradient(0deg, #1B3E92 0%, #719BFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .xians{
      width: 44px;
      height: 4px;
      background-color: #1b3e92;
      margin: 0 auto;
      margin-top: 10px;
    }
  }
  .boxName{
    font-size: 20px;
    line-height: 1.8;
  }
}
.newBox{
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  font-size: 20px;
  line-height: 1.8;
  .list{
    display: flex;
    margin-top: 70px;
    justify-content: space-between;
    .items{
      width: 255px;
      text-align: center;
      .img{
        width: 215px;
        height: 189px;
        background: url(../../assets/my/by.png) no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 50px;
        margin: 0 auto;
        margin-bottom: 20px;
        padding-top: 24px;
        box-sizing: border-box;
      }
      .txt{
        font-size: 22px;
        font-weight: 600;
        line-height: 1.5;
	      color: #333640;
      }
    }
  }
}
#zxfw{
  padding-top: 40px;
  // padding-bottom: 50px;
  // background: url(../../assets/my/bg2.jpg) no-repeat;
  // background-size: 100% 100%;
  .zxfw-box {
    max-width: 1200px;
    margin: 0 auto;
    // box-shadow: 0px 4px 8px 5px rgba(0,0,0,0.05);
    // border-radius: 0px 0px 0px 0px;
    background: #F5F7FA !important;
    padding: 30px 0 50px;
  }
  .bot-tit{
    // color: #fff;
  }
  .context{
    padding: 0 2vw;
    box-sizing: border-box;
    max-width: 1200px;
    margin: 0 auto;
    // color: #fff;
    margin-top: 20px;
    line-height:1.8;
    // color: #ffffff;
    font-size: 20px;
  }
}
.listw{
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  justify-content:space-between;
  .jtBox{
    padding-top: 60px;
    img{
      width: 50px;
    }
  }
  .items{
    width: 300px;
    
    img{
      margin-bottom: 20px;
    }
    .name{
      margin-bottom: 20px;
      .numbar{
        font-family: "Microsoft YaHei";
        font-weight: bold;
        font-size: 30px;
        color: #67B7FB;
        line-height: 30px;
        height: 36px;
        background: linear-gradient(0deg, #1B3E92 0%, #719BFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .xians{
        width: 44px;
        height: 4px;
        background-color: #1b3e92;
        margin: 0 auto;
        margin-top: 10px;
      }
    }
    .txt{
      font-size: 20px;
      line-height: 1.8;
      text-align: center;
    }
  }
}

.zijg{
  padding-top: 30px;
  .bg {
    margin-top: 30px;
    img {
      width: 100% !important;
      max-width: 1200px;
    }
  }
}

.bot-line {
  margin: 0 auto;
  width: 84px;
  height: 4px;
  background: linear-gradient(270deg, #1d3e95 0%, #4840c2 100%);
  border-radius: 4px 4px 4px 4px;
  text-align: center;
}
.bot-tit {
  margin: 0 auto;
  margin-top: 22px;
  // height: 40px;
  font-family: Inter;
  font-weight: 400;
  font-size: 36px;
  color: #080808;
  line-height: 40px;
  position: relative;
  .bot-bg {
    height: 50px;
    font-family: Inter;
    font-weight: 700;
    font-size: 36px;
    color: rgba(194, 194, 194, 0.12);
    line-height: 50px;
    text-align: center;
    position: absolute;
    top: 5px;
    left: 50%;
    transform: translate(-50%, 0);
    white-space: nowrap;
  }
}
.bot-tit-en {
  font-weight: 600 !important;
}
.insd {
  padding: 0 2vw;
  box-sizing: border-box;
}
.aboutus {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .info-bot {
    width: 100%;
    .body-cont {
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 20px;
    }
    .bot-line {
      margin: 0 auto;
      width: 84px;
      height: 4px;
      background: linear-gradient(270deg, #1d3e95 0%, #4840c2 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
    }
    .bot-tit {
      margin: 0 auto;
      margin-top: 22px;
      // height: 40px;
      font-family: Inter;
      font-weight: 400;
      font-size: 36px;
      color: #080808;
      line-height: 40px;
      position: relative;
      .bot-bg {
        height: 50px;
        font-family: Inter;
        font-weight: 700;
        font-size: 36px;
        color: rgba(194, 194, 194, 0.12);
        line-height: 50px;
        text-align: center;
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
      }
    }
    .bot-hz{
      padding-top: 30px;
    }
    .bot-cont {
      // padding-bottom: 100px;
      position: relative;
      .cont-tit {
        // padding: 0 2vw;
        box-sizing: border-box;
        max-width: 1200px;
        margin: 0 auto;
        margin-bottom: 50px;
        font-family: Inter;
        font-size: 20px;
        // color: #61656c;
        line-height: 2;
        text-align: center;
        margin-top: 50px;
      }
    }
    .cont1 {
      width: 100%;
      // padding-bottom: 50px;
      // background: url(../../assets/my/bg1.jpg) no-repeat;
      // background-size: 100% 100%;
    }
    
    .zxyj {
      display: flex;
      align-items: center;
      position: relative;
      padding-top: 40px;
      
      .context {
        font-size: 14px;
        color: #666666;
        line-height: 40px;
        text-align: left;
      }
    }
    .hzzd {
      display: flex;
      padding-top: 50px;
      img {
        width: 50%;
      }
      .cont-right {
        width: 50%;
        box-sizing: border-box;
        font-size: 14px;
        color: #666666;
        background: #f5f7fa;
        line-height: 40px;
        text-align: left;
        font-family: Inter;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0% 5%;
        box-sizing: border-box;

        .tit1 {
          font-size: 16px;
          color: #333640;
          line-height: 30px;
          text-align: left;
          margin-bottom: 15px;
          text-align: justify;
        }
        .tit2 {
          display: flex;
          align-items: center;
          margin-top: 20px;
          img {
            height: 28px;
            width: 28px;
          }
          span {
            font-size: 16px;
            color: #61656c;
            line-height: 22px;
            text-align: left;
            margin-left: 10px;
          }
        }
      }
    }
    .zzjg {
      padding-top: 50px;
      img {
        width: 95%;
      }
    }
    .cooperate {
      max-width: 1200px;
      margin: 0 auto;
      ::v-deep .el-carousel__arrow {
        width: 60px;
        height: 60px;
      }
      ::v-deep .el-carousel__item {
        background-color: transparent;
      }
      .el-carousel {
        background-color: transparent;
      }
      .cont-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 2px 0;
        .items {
          width: calc(33% - 10px);
          height: auto;
          box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          &:nth-child(4n) {
            margin-right: 0px;
          }
          img {
            width: 100%;
            height: auto;
          }
          .title-box {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            border-top: 1px solid #d8d8d8;
            box-sizing: border-box;
          }
        }
      }
    }
    .cooper-cont {
      width: 100%;
      height: 460px;
      background: rgba(248, 245, 245, 0.8);
      margin-top: -80px;
      .cont-context {
        max-width: 1200px;
        margin: 0 auto;
        padding-top: 100px;
        .cont-top {
          display: flex;
          .items {
            width: calc(25% - 10px);
            display: flex;
            .top {
              .top-tit {
                height: 60px;
                font-family: D-DIN, D-DIN;
                font-size: 28px;
                color: #080808;
                line-height: 60px;
                font-family: Inter;
                text-align: left;
                span {
                  font-size: 16px;
                  color: #080808;
                  line-height: 30px;
                }
              }
              .text {
                text-align: left;
                font-size: 14px;
                color: #666666;
                line-height: 30px;
              }
            }
            .top-line {
              width: 1px;
              height: 200px;
              background: #cccccc;
              margin-left: 20px;
            }
          }
          .its {
            padding-left: 20px;
          }
        }
        .cont-bot {
          display: flex;
          justify-content: space-between;
          margin-top: 50px;
          .box-kuang {
            max-width: 1200px;
            height: 32px;
            margin: 0 auto;
            position: relative;
            display: flex;
            align-items: center;
            .bot-line {
              max-width: 1200px;
              height: 0px;
              border: 1px solid #cccccc;
            }
            .bot-box{
              position: absolute;
              width: 20px;
              height: 20px;
              border: 1px solid #1B3E92;
              border-radius: 50%;
              .box{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 10px;
                height: 10px;
                background: #1B3E92;
                border-radius: 50%;
              }
            }
            .box1{
              left: 10%;
            }
            .box2{
              left: 35%;
            }
            .box3{
              left: 60%;
            }
            .box4{
              left: 85%;
            }
          }
        }
      }
    }
  }
}
.swiper3 {
  max-width: 1200px;
  margin: 0 auto;
  z-index: 999;
  // height: 200px;
  overflow: hidden;
  position: relative;
  .swiper-button-prev {
    width: 60px;
    height: 60px;
    font-size: 24px;
    background: rgba(8, 8, 8, 0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: "";
    }
  }
  .swiper-button-next {
    width: 60px;
    height: 60px;
    background: rgba(8, 8, 8, 0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: "";
    }
  }
  .swiper-slide {
    text-align: center;
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  
  .listw {
    width: 600px;
    flex-wrap: wrap;
    .items {
      width: 240px !important;
    }
    .special {
      display: none;
    }
  }
  .list {
    margin: 0 auto;
    width: 600px;
    flex-wrap: wrap;
    .items {
      width: 250px !important;
    }
    .special {
      display: none;
    }
  }
}
@media (max-width: 600px) {
  .pc{
    display: none!important;
  }
  .yd{
    display: block!important;
  }
  .boxName{
    font-size: 14px !important;
    width: 300px;
    margin: 0 auto;
  }
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .page-text {
    width: 100px !important;
  }
  .content-photo {
    display: none !important;
  }
  .zijg {
    position: relative;
    padding-top: 30px !important;
    .tops {
      top: -10px !important;
    }
    .bg {
      margin-top: 20px !important;
      padding: 0 2vw;
      box-sizing: border-box;
      pointer-events: none;
      img {
        width: 100% !important;
      }
    }
  }
  .listw {
    flex-direction: column;
    align-items: center;
    .jtBox {
      display: none !important;
    }
    .items {
      margin-bottom: 20px;
    }
  }
  .numbar {
    font-size: 16px !important;
  }
  .txt {
    font-size: 14px !important;
  }
  .list {
    flex-direction: column;
    align-items: center;
    .items {
      margin-bottom: 20px;
    }
    // .items {
    //   width: 90px !important;
    //   .img {
    //     width: 90px !important;
    //     height: 90px !important;
    //     background-size: cover !important;
    //   }
    // }
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .cont-tit,.insd,.context {
    box-sizing: border-box;
    padding: 0 20px !important;
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
}
</style>
